import type { ComponentProps, ComponentPropsWithoutRef, JSXElementConstructor, ReactElement } from 'react'

import { extractElementText } from 'lib/extractElementText'
import { getNavigationId } from 'lib/getNavigationId'

import { Heading } from 'components/Heading'

type Props = Omit<ComponentPropsWithoutRef<'section'>, 'title' | 'label'> & {
	title: ReactElement<any, string | JSXElementConstructor<any>> | string | undefined
	label?: string
	level: number
	prefix?: string

	renderHeading?: (props: ComponentProps<typeof Heading>) => React.JSX.Element
}

export const Section = ({
	title,
	label = extractElementText(title),
	level,
	prefix,
	children,
	renderHeading = (props) => <Heading {...props} />,
	...rest
}: Props) => {
	const id = getNavigationId(label, prefix)

	return (
		<section id={id} style={{ width: '100%' }} {...rest}>
			{renderHeading({
				level,
				id,
				exposeId: false,
				label,
				children: title,
			})}
			{children}
		</section>
	)
}
